export const getters = {
  regulationtype: state => state.regulationtype,
  regulationtypes: state => state.regulationtypes
}

const GET_REGULATIONTYPE = 'regulationtype/regulationtype'
const GET_REGULATIONTYPES = 'regulationtype/regulationtypes'

export const gettersTypes = {
  GET_REGULATIONTYPE,
  GET_REGULATIONTYPES
}
export default getters



// WEBPACK FOOTER //
// ./src/store/module/regulationtype/getters.js